import { useMutation } from '@tanstack/react-query';
import { useEmployeePortalAuth } from '@/context/EmployeeAuthContext';
import { updateEmployeeLanguage } from '@/api/auth';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { TranslationNS } from '@gokrew/models/constants';

export function useUpdateEmployeeLanguage() {
  const { fetchUser } = useEmployeePortalAuth();
  const { i18n, t } = useTranslation(TranslationNS.Common);

  return useMutation({
    mutationFn: (language: string) => updateEmployeeLanguage(language),
    onSuccess: async (_, language) => {
      try {
        await fetchUser();
        i18n.changeLanguage(language);
      } catch {
        toast.error(t('top_nav.language_update_failed'));
      }
    },
    onError: () => {
      toast.error(t('top_nav.language_update_failed'));
    },
  });
}
